import React from "react";
import {
  Grid,
  GridItem,
  Input,
  Button
} from "@sainsburys-tech/fable";
import PropTypes from "prop-types";
import FormWrapper from "../FormWrapper";
import StoreZoneSceneLevelsFormContainer from "./StoreZoneSceneLevelsFormContainer";
import ValidationSummary from "../ValidationSummary";
import * as allowedRampLevelSeconds from "../../utils/allowedRampLevelSeconds";
import ButtonWithApiCall from "../ButtonWithApiCall";

const options = allowedRampLevelSeconds.rampLevelSeconds.map(x => {
  return {
    label: x,
    value: x
  };
});

const StoreZoneSceneLevelsForm = props => (
  <FormWrapper isDirty={props.isDirty}>
    <form>
      {props.zoneSceneLevels.scenes.map(zoneScene => {
        return (
          <Grid key={zoneScene.scene.name} cols={1}>
            <div
              key={zoneScene.scene.name}
              className="cb-u-section cb-c-store-zone-scene-levels-form__section"
            >
              <GridItem>
                <h4>{zoneScene.scene.description}</h4>
                {!props.hasLuxMeter && (
                  <div>
                    <Input
                      name={props.fields.valuePercentage.name}
                      label="Lighting Level (%)"
                      value={
                        zoneScene.value
                          ? zoneScene.value.level.valuePercentage.toString()
                          : ""
                      }
                      status={
                        props.errors[
                          `${zoneScene.scene.name}.${
                            props.fields.valuePercentage.name
                          }`
                        ]
                          ? { type: "error", message: props.errors[`${zoneScene.scene.name}.${props.fields.valuePercentage.name}`] }
                          : undefined
                      }
                      onChange={e =>
                        props.handleInputChange(
                          zoneScene.scene.name,
                          props.fields.valuePercentage,
                          e.target.value
                        )
                      }
                    />
                    <Input
                      name={props.fields.rampLevelSeconds.name}
                      label="Ramp Time (s)"
                      value={`${zoneScene.value.rampLevelSeconds}`}
                      status={
                        props.errors[
                          `${zoneScene.scene.name}.${
                            props.fields.rampLevelSeconds.name
                          }`
                        ]
                          ? { type: "error", message: props.errors[`${zoneScene.scene.name}.${props.fields.rampLevelSeconds.name}`] }
                          : undefined
                      }
                      onChange={e =>
                        props.handleInputChange(
                          zoneScene.scene.name,
                          props.fields.rampLevelSeconds,
                          e.target.value
                        )
                      }
                    />
                  </div>
                )}

                {props.hasLuxMeter &&
                  (!zoneScene.scene.luxBandsAreEnabled && (
                    <div>
                      <Input
                        name={props.fields.valuePercentage.name}
                        label="Set light level to"
                        value={
                          zoneScene.value
                            ? zoneScene.value.level.valuePercentage.toString()
                            : ""
                        }
                        status={
                          props.errors[
                            `${zoneScene.scene.name}.${
                              props.fields.valuePercentage.name
                            }`
                          ]
                            ? { type: "error", message: props.errors[`${zoneScene.scene.name}.${props.fields.valuePercentage.name}`] }
                            : undefined
                        }
                        onChange={e =>
                          props.handleInputChange(
                            zoneScene.scene.name,
                            props.fields.valuePercentage,
                            e.target.value
                          )
                        }
                      />
                      <Input
                        name={props.fields.rampLevelSeconds.name}
                        label="Ramp"
                        value={`${zoneScene.value.rampLevelSeconds}`}
                        status={
                          props.errors[
                            `${zoneScene.scene.name}.${
                              props.fields.rampLevelSeconds.name
                            }`
                          ]
                            ? { type: "error", message: props.errors[`${zoneScene.scene.name}.${props.fields.rampLevelSeconds.name}`] }
                            : undefined
                        }
                        onChange={e =>
                          props.handleInputChange(
                            zoneScene.scene.name,
                            props.fields.rampLevelSeconds,
                            e.target.value
                          )
                        }
                      />
                    </div>
                  ))}
              </GridItem>

              {props.hasLuxMeter &&
                (zoneScene.scene.luxBandsAreEnabled && (
                  <div>
                    <GridItem>
                      <p>
                        The zone will use Lux sensors during trading to optimise
                        the lighting level during different daylight condtions.
                        The scene must have a default lighting level, the scene
                        can have multiple lux bands and corresponding light
                        levels.
                      </p>
                    </GridItem>
                  </div>
                ))}

              <GridItem>
                {props.hasLuxMeter &&
                  (zoneScene.scene.luxBandsAreEnabled && (
                    <div>
                      <StoreZoneSceneLevelsFormContainer
                        {...props}
                        zoneScene={zoneScene}
                        scene={zoneScene.scene.name}
                      />
                    </div>
                  ))}{" "}
              </GridItem>
            </div>
          </Grid>
        );
      })}
      <Grid cols={1}>
        <GridItem>
          <div>
            {props.errorSubmitting && (
              <div>
                <span>There was an error submitting</span>
              </div>
            )}
            {props.summaryErrors.length > 0 && (
              <ValidationSummary errors={props.summaryErrors} />
            )}
            <ButtonWithApiCall
              type="submit"
              onClick={() => props.handleSubmit()}
              onFailed={() => props.onFailed()}
              isFullWidth
              disabled={!props.isValid || props.isSubmitting}
              onValidate={props.onValidate}
            />
          </div>
        </GridItem>
      </Grid>
    </form>
  </FormWrapper>
);

StoreZoneSceneLevelsForm.propTypes = {
  zoneSceneLevels: PropTypes.shape({
    storeName: PropTypes.string,
    zone: PropTypes.shape({
      name: PropTypes.string,
      hasLuxMeter: PropTypes.bool
    }),
    scenes: PropTypes.arrayOf(
      PropTypes.shape({
        scene: PropTypes.shape({
          name: PropTypes.string,
          description: PropTypes.string,
          luxBandsAreEnabled: PropTypes.bool
        }),
        value: PropTypes.shape({
          rampLevelSeconds: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
          ]),
          level: PropTypes.shape({
            valuePercentage: PropTypes.oneOfType([
              PropTypes.string,
              PropTypes.number
            ])
          })
        }),
        luxBands: PropTypes.arrayOf(
          PropTypes.shape({
            luxLevelGreaterThan: PropTypes.oneOfType([
              PropTypes.string,
              PropTypes.number
            ]),
            rampLevelSeconds: PropTypes.oneOfType([
              PropTypes.string,
              PropTypes.number
            ]),
            level: PropTypes.shape({
              valuePercentage: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number
              ])
            })
          })
        )
      })
    )
  }).isRequired,

  fields: PropTypes.shape({
    valuePercentage: PropTypes.shape({
      name: PropTypes.string,
      rules: PropTypes.array
    }),
    rampLevelSeconds: PropTypes.shape({
      name: PropTypes.string,
      rules: PropTypes.array
    }),
    luxLevelGreaterThan: PropTypes.shape({
      name: PropTypes.string,
      rules: PropTypes.array
    })
  }).isRequired,
  errors: PropTypes.shape({}).isRequired,
  errorSubmitting: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  isValid: PropTypes.bool.isRequired,
  scenes: PropTypes.array.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onAddLuxBand: PropTypes.func,
  onRemoveLuxBand: PropTypes.func,
  summaryErrors: PropTypes.array,
  isDirty: PropTypes.bool,
  onValidate: PropTypes.func.isRequired
};
StoreZoneSceneLevelsForm.defaultProps = {
  summaryErrors: []
};

export default StoreZoneSceneLevelsForm;
